// extracted by mini-css-extract-plugin
export default {"page":"PX","headerwrap":"QX","headerblock":"RX","textwrapper":"SX","text":"TX","closerlook":"UX","arrowwrap":"VX","icon":"WX","updown":"XX","products":"YX","system":"ZX","systemimage":"aY","cards":"bY","note":"cY","fadein":"eY"};
    if(module.hot) {
      // 1737143663834
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  